import { Contract, FormInput } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

const ContractAgreementDetailParagraph = () => {
  const { itemName, setItemAndDetailValue, displayMode } =
    useFormikContractHelpers();
  const { t } = useTranslation();

  const onDefaultValueChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setItemAndDetailValue<string>(
      `content.paragraphAgreementTemplate.defaultValue`,
      event.target.value
    );
  };

  return (
    <Contract.SideMenu.AgreementDetail.Wrapper
      name={`${itemName}.content.paragraphAgreementTemplate.title`}
      label={t('input.label.title')}>
      <FormInput.Field
        name={`${itemName}.content.paragraphAgreementTemplate.defaultValue`}
        label={t('input.placeholder.paragraph-agreement-text')}
        onChange={onDefaultValueChange}
        displayMode={displayMode}
      />
    </Contract.SideMenu.AgreementDetail.Wrapper>
  );
};

export default ContractAgreementDetailParagraph;
